export interface SGTEntidad{
       
    idEntidad: string;
    entidad: string;
  
    
}
export class SGTEntidad implements SGTEntidad {
    constructor(init: SGTEntidadFormValues) {
        Object.assign(this, init);
    }
}
export class SGTEntidadFormValues {
   
    idEntidad: string ='';
    entidad: string ='';

    constructor(SGTEntidad?: SGTEntidadFormValues) {
        if(SGTEntidad){

            this.idEntidad = SGTEntidad.idEntidad || '';
            this.entidad = SGTEntidad.entidad || '';
        }
    }
}